// provides a static, inherited property called "ClassName" that provides a non-derived class name value for comparison
export default class ClassName {
    constructor() {

    }

    static ClassName() {
        return "ClassName";
    }
}